/**
 * File: activityList.js
 * Project: educore
 * Created Date: 2018-12-10
 * Author: Jeevanantham Nagarathinam
 * Screen : FE162
 * -----
 * Last Modified: 2018-12-10
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

//import templatePopLoader from '../../generic/views/loader.html';
//import teacherSubViewTpl from '../views/teacherSubjectView.html';
// Modified By: Raziya S

class TraditionalActivityListController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, CONSTANTS, NO_SHARE_AFL_SCHOOLS,
        qpHandler) {

        //CurrentPage.setTitle("Activity List")
        let self = this;

        $scope.fee_status_label = true
        $scope.no_share_afl = false
        let academicDet = localStorageService.get('authoringData')
        $scope.myActivityList = [];
        let academicDetails = {
            school_id: academicDet.school_id,
            batch_id: academicDet.batch_id,
            curriculum_id: academicDet.curriculum_id,
            subject_id: academicDet.subject_id,
            session_id: academicDet.session_id,
            class_id: academicDet.class_id,
            academic_year: academicDet.academic_year,
            is_traditional_activity: true
        }
        $scope.myuserId = localStorageService.get("user_id")
        let ad_no = localStorageService.get("st_admission_number")
        console.log(ad_no)
        let features = localStorageService.get("feature_privileges");
        let activityUserAccess = _.filter(features, function (feature) {
            return feature.feature_id === "activityList";
        });
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
            return feature.module_state == "activityList"
        })
        $scope.activityUserPrivilege = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function (tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function (privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
            })
        }
        function _isNO_SHARE_AFL_SCHOOLS() {
            let school_id = localStorageService.get("school_id")
            if (NO_SHARE_AFL_SCHOOLS && NO_SHARE_AFL_SCHOOLS.SCHOOL_IDS.indexOf(school_id) !== -1) {
                $scope.no_share_afl = true
            }
        }
        let getAllActivity = () => {
            //To get assignee 
            let _is_teacher = false
            if ($scope.activityUserPrivilege.attendExam && $scope.activityUserPrivilege.attendExam.read)
                academicDetails.student_id = $scope.myuserId

            //To get creator 
            if ($scope.activityUserPrivilege.createActivity && $scope.activityUserPrivilege.createActivity.create){
                localStorageService.set("is_staff", true)
                $scope.is_staff = true
                academicDetails.teacher_id = $scope.myuserId
            }

            //To get approver details
            if ($scope.activityUserPrivilege.approveQuestionPaper && $scope.activityUserPrivilege.approveQuestionPaper.create)
                academicDetails.approver_id = $scope.myuserId

            authService.callAPI(activityCons.API_GET_ALL_ACTIVITY, "POST", academicDetails, (response) => {
                console.log(response)
                if (response.result && response.result.status && response.result.data.data) {
                    let myActivityList = response.result.data.data
                    for(let i = 0 ; i < myActivityList.length; i++){
                        myActivityList[i]['showReport'] = true
                        if(myActivityList[i]['status'] != "published"){
                            if(!$scope.is_staff){
                                myActivityList[i]['showReport'] = false
                            }
                        }
                    }
                    if (_is_teacher) {
                        _isNO_SHARE_AFL_SCHOOLS()
                    }
                    setNewStatusPartial(myActivityList)
                    $scope.myActivityList = myActivityList
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    //error
                }
                
            })
        }

        let setNewStatusPartial = (myActivityList = []) => {
            try {
                for (let index = 0; index < myActivityList.length; index++) {
                    let element = myActivityList[index];
                    try {
                        if(element){
                            let temp_sections = element.temp_sections
                            let sections = element.sections 
                            if(element.status == 'created'){
                                let partial = 0
                                if(temp_sections && temp_sections.length){
                                    partial++
                                }
                                if(!sections || !sections.length){
                                    partial++
                                }else{
                                    let questions = _.flatten(_.pluck(
                                        sections, "questions"
                                    ))
                                    if(!questions || !questions.length){
                                        partial++
                                    }
                                }
                                if(partial){
                                    element.status = 'partial'
                                }
                            }
                        }
                    } catch (e1) {
                        console.log(e1)
                    }
                }
            } catch (e) {
                console.log(e)
            }
        }
        let getThemeData = (res) => {
            console.log(academicDet)
            authService.callAPI(activityCons.API_GET_THEMES, "POST", academicDet, (response) => {
                console.log(response)
                if (response.result && response.result.status && response.result.data.themeList) {
                    $scope.themes = response.result.data.themeList;
                    res(response.result.data.themeList)
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    //error
                }
            })
        }

        let getTraditionalActivityDet = (qpDet) => {
            authService.callAPI(activityCons.API_GET_TRADITIONAL_ACTIVITY, "POST", qpDet, (response) => {
                if (response.result && response.result.status && response.result.data.data) {
                    let result = response.result.data.data[0]
                    academicDetails['qp_id'] = result.basic_details[0]._id
                    academicDetails['themes'] = $scope.themes
                    academicDetails['question_paper_title'] = result.basic_details[0].question_paper_title
                    academicDetails['is_traditional_activity'] = true
                    academicDetails[' isNotAddToQp'] = false

                    academicDetails['theme_id'] = result.basic_details[0].theme_id
                    academicDetails['practice_qn'] = result.basic_details[0].practice_qn
                    if ((result.temp_sections && result.temp_sections.length > 0) || (result.sections && result.sections.length > 0)) {
                        academicDetails["isQuestionAvailable"] = true
                        localStorageService.set('academicDetails', academicDetails)
                        $state.go("formatQuestion", {
                            'qpId': result.basic_details[0]._id
                        })
                    } else {
                        academicDetails["isQuestionAvailable"] = false
                        localStorageService.set('academicDetails', academicDetails)
                        $state.go('createActivity', {
                            'qpId': result.basic_details[0]._id,
                            'activityId': result.basic_details[0].activity_id
                        })
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    //error
                }
            })
        }
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Activity List"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }

            let academics = {
                school_id: academicDet.school_id,
                batch_id: academicDet.batch_id,
                curriculum_id: academicDet.curriculum_id,
                subject_id: academicDet.subject_id,
                session_id: academicDet.session_id,
                class_id: academicDet.class_id,
                academic_year: academicDet.academic_year
            }

            //String - Teaching plan id
            let tpId = $state.params.planId

            //Boolean - Activity created or not
            $scope.isActivityCreated = false

            /*
            * Function to get assigned users
            * 
            */
            authService.callAPI("/v0/tp-reports/student-details", "POST", academics, function (response) {
                if (response.result && response.result.data && response.result.data.data.length > 0) {
                    try {
                        $scope.isLoading = false

                        $scope.studentList = response.result.data.data;
                        //To sort student list
                        $scope.studentList.sort(function (a, b) {
                            var textA = a.name.toUpperCase();
                            var textB = b.name.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                        localStorageService.set("students_this_class", $scope.studentList)
                    } catch (ex) {
                        console.log(ex);
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            });
            getAllActivity()
        }
        function getSchoolTokens(schoolId) {
            var dummySchool = [{
                "_id": "2ebFyzgjEwmdvep5L",
                "school_name": "The Oxford School,Trivandrum",
                "site_url": "http://35.200.206.239:3600",
                "file_server": "http://35.200.206.239:4000",
                // "school_data_url" : "https://portal.oxford.edu.in/index.php/portal_data_contract",
                // "school_data_token" : "d8ba88f080664a1420d2d080b658fc04"
                "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
                "school_data_token": "53d553cca766bb843eeb6464608ac93e"
            },
            {
                "_id": "Mvb8uY53ijBX9DNJS",
                "school_name": "The Oxford School,Kollam",
                "site_url": "http://35.200.206.239:3600",
                "file_server": "http://35.200.206.239:4000",
                // "school_data_url" : "https://portal.oxfordkollam.edu.in/index.php/portal_data_contract",
                // "school_data_token" : "795dce7a5fa85ef8d4945441549b6578"
                "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
                "school_data_token": "25c921722bec9527d59eb0e34713347c"
            },
            {
                "_id": "f5BCz8T7LqzpFsSP3",
                "school_name": "The Oxford School,Calicut",
                "site_url": "http://35.200.206.239:3600",
                "file_server": "http://35.200.206.239:4000",
                // "school_data_url" : "http://portal.oxfordcalicut.com/index.php/Portal_data_contract",
                // "school_data_token" : "cded12b4cd909d4e00610ff0699ca069"
                "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
                "school_data_token": "aa8d7f8e0352b2712b9e80cf25bb60d4"
            },
            {
                "_id": "CPpbKPQTcuG97i3kv",
                "school_name": "The New Indian Model School,Dubai",
                "site_url": "http://104.199.53.109:3700",
                "file_server": "http://104.199.53.109:4000",
                // "school_data_url" : "https://portal.nimsdxb.com/index.php/portal_data_contract",
                // "school_data_token" : "e370c37780b957637493e9727c9b304d",
                // "school_data_url" : "http://qnap.ddns.cyberoam.com:3000/rims-tools/api/App",
                // "school_data_token" : "ed0a5a7f2b76668e8a6dd3388868c068"
                "school_data_url" : "https://bm-harvest.globtech.in/api/App",
                "school_data_token" : "7a9d733269d23bc35b04b56dc855d330"
            },
            {
                "_id": "m2LMtqaESFZf6xDE8",
                "school_name": "The Central School,Dubai",
                "site_url": "http://104.199.53.109:3700",
                "file_server": "http://104.199.53.109:4000",
                // "school_data_url" : "https://portal.centraldxb.com/index.php/portal_data_contract",
                // "school_data_token" : "f2f78f635a660af6257dab8da79c650f"
                "school_data_url" : "https://bm-harvest.globtech.in/api/App",
                "school_data_token" : "47e2b919b8551d762e1dd1f5769b66ba"
            },
            {
                "_id": "2FwuqhgeoKt6SQiCG",
                "school_name": "The New Indian Model School,Al-Ain",
                "site_url": "http://104.199.53.109:3700",
                "file_server": "http://104.199.53.109:4000",
                // "school_data_url" : "https://portal.nimsalain.com/index.php/portal_data_contract",
                // "school_data_token" : "874d4634f7c741f397045aeb7fd133c6"
                "school_data_url" : "https://bm-harvest.globtech.in/api/App",
                "school_data_token" : "0ae409a7d98dde57b35a4643d2354906"
            },
            {
                "_id": "ps4vyLJhQvPZjfxaH",
                "school_name": "The New Indian Model School,Sharjah",
                "site_url": "http://104.199.53.109:3700",
                "file_server": "http://104.199.53.109:4000",
                // "school_data_url" : "https://portal.nimsshj.com/index.php/portal_data_contract",
                // "school_data_token" : "8838d896e6aecc58323ef9b26c374ebe"
                "school_data_url" : "https://bm-harvest.globtech.in/api/App",
                "school_data_token": "99d351fe9165be1c0cf35fa0a0885c17"
            }]
            let ex = _.find(dummySchool, function (one) {
                return one._id == schoolId
            })
            return ex
        }
        function feesCheckOneStudent(id) {
            let school_id = localStorageService.get("school_id")
            let tokens = getSchoolTokens(school_id)
            let admn_no = localStorageService.get('admission_no')


            if (!admn_no) {
                admn_no = localStorageService.get('st_admission_number')
            }
            if (admn_no) {
                authService.callAPI("/v0/parent/portal/fee/", "POST", {
                    school_data_token: tokens.school_data_token,
                    school_data_url: tokens.school_data_url,
                    admn_no: admn_no
                }, function (response) {
                    try {
                        if (response.result.status.code == 200) {
                            if (response.result.data && response.result.data.details) {
                                self.feesDocument = response.result.data.details
                                var exmpList = (response.result.data.exemption_list)?response.result.data.exemption_list:[]; 
                                _.each(self.feesDocument, function (det, index) {
                                    if (det.fee_last_date) {
                                        let someDate = new Date(det.fee_last_date);
                                        let numberOfDaysToAdd = 20;
                                        someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
                                        det.fee_last_date = someDate
                                    }
                                    // det.fee_last_date = new Date(det.fee_last_date)
                                    let today = new Date()
                                    det.fee_last_date.setHours(0, 0, 0, 0);
                                    today.setHours(0, 0, 0, 0);
                                    if (det.fee_last_date <= today) {
                                        if (det.fee_status === "Pending"  && det.blocking_status === "Y") {
                                            var isExepted = exmpList.includes(admn_no);
                                            if(isExepted){
                                                $scope.fee_status_label = true
                                            } else {
                                                $scope.fee_status_label = false
                                            }
                                        } else {
                                            $scope.fee_status_label = true
                                        }
                                    }
                                })
                                redirectToReport(id)
                            } else {
                                $scope.fee_status_label = true
                                redirectToReport(id)
                            }
                        } else {
                            $scope.fee_status_label = false
                        }
                    } catch (ex) {
                        redirectToReport(id)
                        console.log(ex);
                    }
                })
            }else{
                redirectToReport(id)
            }


        }
        function redirectToReport(id) {
            $scope.isLoading = false
            if (!$scope.fee_status_label) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Information')
                        .textContent('Sorry, as fees dues are there, cannot view the report!')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('Got it!')
                    // .targetEvent(ev)
                );
                return false
            }
            $state.go("activitypersstudentCtrl", {
                student_id: localStorageService.get('user_id'),
                qp_id: id,
                page: 1,
                isFromModule: false
            })
        }
        $scope.viewComment = (ev, activity) => {
            if(activity && activity.approver_comment){
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Approver comment')
                        .textContent(activity.approver_comment)
                        .ariaLabel('Alert Dialog Demo')
                        .ok('OK')
                        .targetEvent(ev)
                );
            }
            
        }
        $scope.gotoReport = (id) => {
            if ($scope.activityUserPrivilege.conductingActivity && $scope.activityUserPrivilege.conductingActivity.create) {
                $state.go("reportsMainCtrl", {
                    prevParams: {
                        planId: null
                    },
                    qpId: id,
                    isFromModule: false
                })
            } else {
                if (ad_no) {
                    $scope.isLoading = true
                    feesCheckOneStudent(id)
                } else {
                    redirectToReport(id)
                }

            }

        }
        this.$onDestroy = () => {

        }
        $scope.collapseAll = function (data) {
            data.expanded = !data.expanded;
        };
        $scope.redirectToCreate = () => {
            $state.go("createActivity", {
                qpId: null,
                activityId: null
            }, {
                reload: true
            })
        }
        $scope.toggleExpansion = function (accordianData, selectedData, index) {
            _.each(accordianData, function (data, dataIndex) {
                if (dataIndex != index)
                    data.expanded = false;
                else
                    data.expanded = !selectedData.expanded;
            })
        }
        $scope.gotoActivityEditPage = (qpId, activityId) => {
            console.log(qpId)
            let qpDet = {
                "qp_id": qpId,
                "activity_id": activityId,
                "teacher_id": localStorageService.get("user_id"),
                "school_id": localStorageService.get("school_id")
            }
            getThemeData((response) => {
                getTraditionalActivityDet(qpDet)
            })
        }
        $scope.gotoSummaryPreview = (qpId) => {
            let qpDet = {
                "qp_id": qpId,
                "teacher_id": localStorageService.get("user_id"),
                "school_id": localStorageService.get("school_id")
            }

            getThemeData((response) => {
                authService.callAPI(activityCons.API_GET_TRADITIONAL_ACTIVITY, "POST", qpDet, (response) => {
                    if (response.result && response.result.status && response.result.data.data) {
                        let result = response.result.data.data
                        academicDetails['theme_id'] = result.theme_id
                        academicDetails['is_traditional_activity'] = result.is_traditional_activity
                        academicDetails['practice_qn'] = result.practice_qn
                        academicDetails['qp_id'] = result._id
                        academicDetails['question_paper_title'] = result.question_paper_title
                        academicDetails['themes'] = $scope.themes
                        localStorageService.set('academicDetails', academicDetails)
                        $state.go('qpSummary', {
                            qpId: qpId
                        })

                    } else {
                        //error
                    }
                })
            })
        }
        $scope.deleteActivty = function (qpId) {
            var confirm = $mdDialog.confirm()
                .textContent('Do you want to delete Activity?')
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function () {
                authService.callAPI(activityCons.API_DELETE_QP + qpId, "POST", {}, function (response) {
                    if (response.result) {
                        toastr.success("Activity deleted successfully")
                        getAllActivity()
                        _.defer(function () {
                            $scope.$apply();
                        });
                    } else {
                        console.log("error : " + response.error)
                        console.log(response.error)
                    }
                })

            }, function () { });
        }

        $scope.share = (activity) => {

            let obj = {
                qp_id: activity._id,
                FILE_UPLOAD_URL: CONSTANTS.FILE_UPLOAD_URL,
                teacher_id: activity.teacher_id,
                user_id: localStorageService.get('user_id'),
                school_id : localStorageService.get("school_id")
            }
            var confirm = $mdDialog.confirm()
                .textContent('This will send email to the parents.Are you sure to send?')
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function () {
                authService.callAPI("/v0/assesment-report/send/link/to/parents", "POST", obj, function (response) {
                    if (response.result) {
                        toastr.success("Activity report link sent Successfully")
                        _.defer(function () {
                            $scope.$apply();
                        });
                    } else {
                        console.log("error : " + response.error)
                        console.log(response.error)
                    }
                })

            }, function () { });
        }
        $scope.updateParentVisibility = (activity) => {
            let obj = {
                school_id : localStorageService.get("school_id"),
                qp_id: activity._id,
                is_visibleto_parents : activity.is_visibleto_parents,
                toastr : toastr
            }
            qpHandler.updateParentVisibility(authService, obj)
        }
    }
}

export default TraditionalActivityListController;



// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/activityList.js